import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import './NotFound.css';
import { Text } from '../components/Text';

export default () => {
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const params = new URLSearchParams();

    if (params.get('mfaSetup') === 'true') {
      history.replace('/dashboard');
    }

    if (location.pathname.includes('mfaSetup')) {
      history.replace('/dashboard');
    }

  }, [location, history]);

  return (
    <div>
      <h3>
        <Text tid="pageNotFound" />
      </h3>
    </div>
    );
};
